import { render } from "./TablaDetalleGafete.vue?vue&type=template&id=fccec5a4"
import script from "./TablaDetalleGafete.vue?vue&type=script&lang=js"
export * from "./TablaDetalleGafete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__